import MembershipAddresses from './MembershipAddresses';

export default MembershipAddresses;
